import { map } from 'rxjs/operators';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class ExternalService extends ApiBase {
  static adminUrl = getApiUrl(API_URL.ADMIN);

  getGlobalReview(storeId: string) {
    return this.api.getJSON(`${ExternalService.adminUrl}/trustedShop?storeId=${storeId}`).pipe(
      map(({ rating, count }) => ({
        ratingValue: +rating,
        ratingCount: +count
      }))
    );
  }

  getCustomerReview(storeId) {
    return this.api.getJSON(`${ExternalService.adminUrl}/trustedShop/reviews?storeId=${storeId}`);
  }
}
